import React from "react";
import "../../../assets/css/seller/components/termsModal/TermsModal.css";
import { AiOutlineClose } from "react-icons/ai";

const TermsModal = ({ show, onClose }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="terms-modal-overlay" onClick={onClose}>
      <div className="terms-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h3 className="terms-modal-title">Seller Terms & Conditions</h3>
          <button
            type="button"
            className="terms-modal-close"
            onClick={onClose}
          >
            <AiOutlineClose size={16} />
          </button>
        </div>

        <div className="terms-modal-body">
          <div className="terms-modal-point">
            <span className="terms-modal-number">1</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Account Eligibility</span>
              Sellers must be 18 or older and provide accurate shop details.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">2</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Handmade products only</span>
              Only handmade and creative products may be listed on CraftHive.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">3</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Product information</span>
              Listings should have accurate details, genuine images, and match
              the actual product in quality.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">4</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Delivery</span>
              Sellers are responsible for delivering orders on time. A fixed
              charge of Rs. 200 applies per order.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">5</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Cancellations</span>
              Orders can be cancelled before dispatch. CraftHive does not offer
              refunds after dispatch.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">6</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Customization</span>
              Custom order details should be discussed with the customer
              through chat before accepting.
            </p>
          </div>

          <div className="terms-modal-point">
            <span className="terms-modal-number">7</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Commission</span>
              CraftHive deducts a commission per sale. The remaining balance
              is added to the seller's wallet.
            </p>
          </div>

          <div className="terms-modal-point terms-modal-point-last">
            <span className="terms-modal-number">8</span>
            <p className="terms-modal-text">
              <span className="terms-modal-heading">Fair use</span>
              Selling prohibited or unsafe items, or violating these terms,
              may lead to account restriction.
            </p>
          </div>
        </div>

        <div className="terms-modal-footer">
          <button
            type="button"
            className="terms-modal-close-button"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;